import { render, staticRenderFns } from "./ClosedProductionCard.vue?vue&type=template&id=5118a9b6&"
import script from "./ClosedProductionCard.vue?vue&type=script&lang=js&"
export * from "./ClosedProductionCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports